import {IUIConfigState} from "../../interfaces";

export const initialConfigState: IUIConfigState = {
    appSettings: null,
    os: null,
    logger: [],
    chat: {
        liveStatus: 0,
        liveStatusV2: null,
        sessionId: null
    },
    staticIndexHTML: null,
    socialUser: null,
    socialUserServerReply: null,
    localStorageUpdates: null,
    fasterq: {
        fasterqLineSelected: -1,
        fasterqNowServicing: '',
        fasterqQueueSelected: -1
    },
    uiSceneConfig: {
        selectedSceneId: null,
        selectedSceneItemId: null,
        sceneItemLocationIndexes: null,
        sceneItemLocationCoords: null,
        sceneItemPlaylistIndexes: null,
        sceneItemSvgColor: {
            itemFillColor: '#FFFFFF',
            itemStrokeColor: '#FFFFFF'
        },
        fontsPreviewed: [],
        lastDuplicationCommand: null,
        lastDuplication: {
            clipboardBlocks: [],
            topLeftXY: [0, 0]
        },
        sceneAnimationClipboard: null,
        breadcrumbs: [],
        previousLinkedSceneId: null,
        previousSlidesSceneId: null
    },
    scheduleSelectionState: {
        scheduler: {
            scheduleId: null,
            unique: null
        }
    },
    touchConfig: {
        sceneId: null,
        ScenePlaylistId: null,
        SceneTitle: null
    },
    editorMode: 'scene-builder'
};
